import {
  Box,
  Button,
  Center,
  Flex,
  IconButton,
  Image,
  Input,
  Spinner,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import { FieldRenderProps } from "react-final-form";
import React, { FC, useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { isEmpty } from "lodash";
import { BsCloudUpload, BsTrashFill } from "react-icons/bs";

interface FileUploadFieldProps {
  isDisabled?: boolean;
  placeholder?: any;
  label?: any;
  setFile?: any;
  isUpdate?: boolean;
  img?: string;
}

const FileUploadField: FC<FileUploadFieldProps> = (props) => {
  const { isDisabled, placeholder, setFile, isUpdate, img } = props;
  const [image, setImage] = useState(isUpdate ? [{ path: img }] : []);
  const [loading, setLoading] = useState(false);
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  const onDrop = useCallback((acceptedFiles: any) => {
    const files: any = [];
    setLoading(true);
    acceptedFiles.forEach(async (file: any) => {
      const { name, type, size } = file;
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = async () => {
        const fileAsDataUrl = reader.result;

        const regExp = /[\u0370-\u03FF]/g;
        let updatedFileName = name;
        if (regExp.test(name)) {
          updatedFileName = name.replace(regExp, "");
        }

        files.push({ name: updatedFileName, type, size, path: fileAsDataUrl });
      };
      setLoading(false);

      setFile(files);
      setImage(files);
      await reader.readAsDataURL(file);
    });

    // console.log('input', input);
    // eslint-disable-next-line
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png", ".jpeg", ".jpg"],
    },
    multiple: false,
    maxSize: 1048576,
  });

  return (
    <>
      <Flex
        border="2px dashed gray"
        p="3"
        flexDirection="column"
        justifyContent="start"
      >
        {!isEmpty(image) && !loading && (
          <IconButton
            onClick={() => {
              setFile([]);
              setImage([]);
            }}
            aria-label="remove-img"
            icon={<BsTrashFill color="red" />}
            size="md"
            mr="auto"
          />
        )}
        <Box {...getRootProps()}>
          <Box
            as={Input}
            {...getInputProps()}
            placeholder={placeholder}
            rounded="sm"
            disabled={isDisabled}
          />

          {!isEmpty(image) && (
            <Box>
              {image.map((img: any, index: any) => (
                <Flex
                  key={index}
                  justifyContent="center"
                  flexDirection={isLargerThan900 ? "row" : "column-reverse"}
                  alignItems="center"
                >
                  <Image boxSize="80px" src={img.path} alt={img.name} m="1" />
                  <Image boxSize="100px" src={img.path} alt={img.name} m="1" />
                  <Image boxSize="150px" src={img.path} alt={img.name} m="1" />
                </Flex>
              ))}
            </Box>
          )}

          <Center my="2">
            <Button leftIcon={<BsCloudUpload />} variant="link">
              {isDragActive && isEmpty(image) ? (
                <Text>Drop the files here ...</Text>
              ) : (
                <Text>
                  {isUpdate ? "Update image" : "Drag & Drop image here"}
                </Text>
              )}
            </Button>
          </Center>
        </Box>
      </Flex>
    </>
  );
};

export default FileUploadField;
